
<template>
    <div>
        <md-card class="card_full_screen">
            <md-card-content>
                <ValidationObserver ref="valObserver">
                    <form>
                        <FadeTransition :duration="400" mode="out-in" v-if="!loading">
                            <div class="md-layout md-alignment-top-left">



                                <div class="md-layout-item md-size-100 md-small-size-100 md-medium-size-100 md-xlarge-size-100">
                                    <div class="title_with_btns">
                                        <div class="titles">
                                            <h3 class="zero_b_margin">{{website.name}}</h3>
                                            <p class="vertically_tight">{{website.address}}</p>
                                        </div>
                                        <website-menu></website-menu>
                                        <div class="btns">
                                            <div class="btns_sxs">
                                                <md-button @click="save" title="Save all changes" :class="getButtonClass('save')">Save</md-button>
                                                <md-button :href="createInvoiceUrl" v-auth-href="{token: userToken}" class="md-info"
                                                           title="Generate New Invoice">Invoice</md-button>
                                                <md-button @click="sendApproval" title="Send Email with link to User (sets state 'awaiting approval', website only accessible via approval url)"
                                                           :disabled="!website.readyForWeb" :class="getButtonClass('request_approval')">Request Approval</md-button>
                                                <md-button @click="goLive" title="Publish Website to Public Internet (sets state 'Live' accessible to public with shortname as subdomain url)"
                                                           :disabled="!website.readyForLive" :class="getButtonClass('go_live')">Go Live</md-button>
                                                <md-button @click="sendTenantWelcome" title="Sends Welcome email to all Tenants"
                                                           :disabled="!website.readyForTenants" :class="getButtonClass('welcome_tenants')">Welcome Tenants</md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="md-layout-item md-size-100">

                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Status
                                        </label>
                                        <div class="md-layout-item md-size-20">
                                            <md-field>
                                                <md-select v-model="website.status">
                                                    <md-option v-for="s in buildingStatuses" :key="s.id" :value="s.id">{{s.name}}</md-option>
                                                </md-select>
                                            </md-field>
                                        </div>
                                        <template v-if="website.siteLive">
                                            <label class="md-layout-item md-size-10 md-form-label">
                                                Live Website
                                            </label>
                                            <div class="md-layout-item md-size-25">
                                                <md-field>
                                                    <md-input v-model="website.siteUrl" disabled />
                                                    <a :href="website.siteUrl" target="_blank" title="Visit link" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                                </md-field>
                                            </div>
                                        </template>
                                        <template v-if="website.previewSiteLive">
                                            <label class="md-layout-item md-size-10 md-form-label">
                                                Approval/Preview
                                            </label>
                                            <div class="md-layout-item md-size-25">
                                                <md-field>
                                                    <md-input v-model="website.approvalId" />
                                                    <a :href="website.previewUrl" v-if="website.previewSiteLive" target="_blank" title="Visit link" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                                </md-field>
                                            </div>
                                        </template>
                                    </div>


                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            PO Number
                                        </label>
                                        <div class="md-layout-item md-size-20">
                                            <md-field>
                                                <md-input v-model="website.generatePoNumber" />
                                                <a @click="toggleStateDetails" title="Toggle Details" class="icon_link"><i class="fas fa-caret-down"></i></a>
                                            </md-field>
                                        </div>
                                        <label class="md-layout-item md-size-10 md-form-label">
                                            User Email
                                        </label>
                                        <div class="md-layout-item md-size-25">
                                            <md-field>
                                                <md-input v-model="website.userEmail" disabled />
                                                <a :href="'mailto:'+ website.userEmail" target="_blank" title="Email User" class="icon_link"><i class="fas fa-caret-right"></i></a>
                                            </md-field>
                                        </div>
                                    </div>

                                    <div class="md-layout md-gutter margin_bottom">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            PoisSearchRadiusMetresOverride
                                        </label>
                                        <div class="md-layout-item md-size-20">
                                            <ValidationProvider name="PoisSearchRadiusMetresOverride" rules="min_value:0|max_value:8000" v-slot="{ passed, failed }">
                                                <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                                    <md-input v-model="website.poisSearchRadiusMetresOverride" type="number" />
                                                    <span class="md-helper-text">850 (default), consider e.g. 4000 for Southampton</span>
                                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                                </md-field>
                                            </ValidationProvider>
                                        </div>


                                        <label class="md-layout-item md-size-15 md-form-label">
                                            SiteMapZoomDefaultOverride
                                        </label>
                                        <div class="md-layout-item md-size-20">
                                            <ValidationProvider name="SiteMapZoomDefaultOverride" rules="min_value:0|max_value:50" v-slot="{ passed, failed }">
                                                <md-field class="val-inset" :class="[ { 'md-error': failed },{ 'md-valid': passed } ]">
                                                    <md-input v-model="website.siteMapZoomDefaultOverride" type="number" />
                                                    <span class="md-helper-text">17 (larger is more zoomed)</span>
                                                    <slide-y-down-transition><md-icon class="error" v-show="failed">close</md-icon></slide-y-down-transition>
                                                    <slide-y-down-transition><md-icon class="success" v-show="passed">done</md-icon></slide-y-down-transition>
                                                </md-field>
                                            </ValidationProvider>
                                        </div>
                                    </div>


                                    <template v-if="stateDetailsVisible">
                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-15 md-form-label top_pad_none">
                                                Ready for Web /<br />
                                                Ready for Approval
                                            </label>
                                            <div class="md-layout-item md-size-85 horizontal_chbs">
                                                <md-checkbox v-for="item in readyReadyForWebItems" :key="item.name" v-model="item.value" disabled>
                                                    {{item.name}}
                                                </md-checkbox>
                                            </div>
                                        </div>

                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-15 md-form-label top_pad_none">
                                                Ready for Live
                                            </label>
                                            <div class="md-layout-item md-size-85 horizontal_chbs">
                                                <md-checkbox v-for="item in readyForLiveItems" :key="item.name" v-model="item.value" disabled>
                                                    {{item.name}}
                                                </md-checkbox>
                                            </div>
                                        </div>

                                        <div class="md-layout md-gutter">
                                            <label class="md-layout-item md-size-15 md-form-label top_pad_none">
                                                Ready for Tenants
                                            </label>
                                            <div class="md-layout-item md-size-85 horizontal_chbs">
                                                <md-checkbox v-for="item in readyForTenantsItems" :key="item.name" v-model="item.value" disabled>
                                                    {{item.name}}
                                                </md-checkbox>
                                            </div>
                                        </div>
                                    </template>




                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Save
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.saveDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.saveTime" />
                                            </md-field>
                                        </div>
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Generate
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.generateDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.generateTime" />
                                            </md-field>
                                        </div>
                                    </div>


                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Approval Sent
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.approvalSentDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.approvalSentTime" />
                                            </md-field>
                                        </div>
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Approved
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.approvedDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.approvedTime" />
                                            </md-field>
                                        </div>
                                    </div>


                                    <div class="md-layout md-gutter margin_bottom">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Live
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.liveDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.liveTime" />
                                            </md-field>
                                        </div>
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Tenant Welcome Sent
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-datepicker v-model="website.tenantWelcomeSentDate" :md-model-type="mdTypeDate" md-immediately>
                                            </md-datepicker>
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.tenantWelcomeSentTime" />
                                            </md-field>
                                        </div>
                                    </div>






                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Shortname
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-field>
                                                <md-input v-model="website.shortName" />
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-15">
                                        </div>
                                        <label class="md-layout-item md-size-5 md-form-label">
                                            Logo Text
                                        </label>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.logoText" maxlength="2" />
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-20">
                                            <md-switch v-model="website.displayInvitesSection">Display Invites Section</md-switch>
                                        </div>
                                    </div>


                                    <div class="md-layout md-gutter margin_bottom">
                                        <label class="md-layout-item md-size-15 md-form-label">
                                            Template
                                        </label>
                                        <div class="md-layout-item md-size-15">
                                            <md-field>
                                                <md-select v-model="website.siteTemplate">
                                                    <md-option v-for="s in siteTemplates" :key="s.id" :value="s.id">{{s.name}}</md-option>
                                                </md-select>
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-15">
                                        </div>
                                        <label class="md-layout-item md-size-5 md-form-label">
                                            PIN
                                        </label>
                                        <div class="md-layout-item md-size-5">
                                            <md-field>
                                                <md-input v-model="website.pin" maxlength="4" />
                                            </md-field>
                                        </div>
                                        <div class="md-layout-item md-size-20">
                                            <md-switch v-model="website.displayProvidersContacts">Display Pin Providers Contacts</md-switch>
                                        </div>
                                    </div>


                                    <div class="md-layout md-gutter">
                                        <div class="md-layout-item md-size-15">
                                        </div>
                                        <div class="md-layout-item md-size-15">
                                        </div>
                                        <div class="md-layout-item md-size-15">
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                        </div>
                                        <div class="md-layout-item md-size-5">
                                        </div>
                                        <div class="md-layout-item md-size-20">
                                            <md-switch v-model="website.displayStreetViewSection">Display StreetView Section</md-switch>
                                        </div>
                                    </div>


                                    <div class="md-layout md-gutter">
                                        <label class="md-layout-item md-size-15 md-form-label top_pad_none">
                                            Banner Image
                                        </label>
                                        <div class="md-layout-item md-size-60">

                                            <md-radio v-for="s in website.bannerBackgroundImages" v-model="website.bannerBackgroundImageId" :key="s.id" :value="s.id" class="radio_large">
                                                <div class="radio_inner">
                                                    <img :src="thumbUrl(s.thumb)" />
                                                    <span>{{s.name}}</span>
                                                </div>
                                            </md-radio>

                                        </div>
                                    </div>


                                </div>

                            </div>
                        </FadeTransition>
                        <div class="loader_wrap" v-if="loading">
                            <loader></loader>
                        </div>
                    </form>
                </ValidationObserver>
            </md-card-content>
        </md-card>
    </div>
</template>
<script>
    import { SlideYDownTransition, FadeTransition } from "vue2-transitions";
    import Loader from "@/components/Loader.vue";

    import Help from "@/ts/Help";
    import NotyTypes from "@/ts/NotyTypes";
    import Api from '@/ts/UvApiService';
    import { BuildingStatus, SiteTemplates } from '@/ts/buildingSpec';
    import WebsiteMenu from "./WebsiteMenu.vue";

    export default {
        components: {
              Loader
            , SlideYDownTransition
            , FadeTransition
            , WebsiteMenu
        },
        data() {
            return {
                loading: true,
                website: null,
                buildingStatuses: [],
                siteTemplates: [],
                stateDetailsVisible: false,
            }
        },
        computed: {
            mdTypeDate() {
                return String;
            },
            suggestedButton() {
                if (this.website.readyForTenants === true)
                    return 'welcome_tenants';
                else if (this.website.readyForLive === true)
                    return 'go_live';
                else if (this.website.readyForWeb === true)
                    return 'request_approval';
                else
                    return 'save';
            },
            readyForTenantsItems() {
                return [{ name: 'siteLive', value: this.website.siteLive }, { name: 'readyForLive', value: this.website.readyForLive }];
            },
            readyForLiveItems() {
                return [{ name: 'hasBeenApproved', value: this.website.hasBeenApproved }, { name: 'hasGenerate', value: this.website.hasGenerate }, { name: 'readyForWeb', value: this.website.readyForWeb }];
            },
            readyReadyForWebItems() {
                return [{ name: 'hasLogoAndShortName', value: this.website.hasLogoAndShortName }, { name: 'hasAddress', value: this.website.hasAddress }, { name: 'hasContacts', value: this.website.hasContacts }
                    , { name: 'hasLocation', value: this.website.hasLocation }, { name: 'hasServiceCharge', value: this.website.hasServiceCharge }, { name: 'hasAmenities', value: this.website.hasAmenities }
                    , { name: 'hasVisitorProcess', value: this.website.hasVisitorProcess }, { name: 'hasTenants', value: this.website.hasTenants }, { name: 'hasPois', value: this.website.hasPois }
                    , { name: 'hasLinkGroups', value: this.website.hasLinkGroups }
                ];
            },
            userToken() {
                return this.token;
            },
            createInvoiceUrl() {
                return `${this.$currentConfig.apiBaseUrl}/websites/create-invoice/${this.website.id}`;
            },
        },
        methods: {
            toggleStateDetails() {
                this.stateDetailsVisible = !this.stateDetailsVisible;
            },
            getButtonClass(btn) {
                return this.suggestedButton === btn ? "md-primary" : "md-info";
            },
            async fetchData() {
                if (!Help.isNullOrUndef(this.$route.params.buildingId)) {
                    if (Help.isNullOrUndef(this.website)) {
                        var res = await Api.websites.getWebsite(this.$route.params.buildingId);
                        this.website = res;
                        this.token = await this.$auth.getTokenSilently();
                    }
                    this.loading = false;
                }
            },
            async save() {
                this.$refs.valObserver.validate().then(async success => {
                    if (!success) {
                        setTimeout(() => {
                            this.notifyErrors(Object.values(this.$refs.valObserver.errors));
                        }, 100);
                        return;
                    }
                    else {
                        await this.saveRaw();//this.$router.push(this.nextUrl);
                    }
                });
            },
            async saveRaw() {
                var res = await Api.websites.saveWebsite(this.website);
                if (res.success === true) {
                    alert("that worked");
                    this.website = res.website;
                }
                else
                    this.showServerFailMessage(res, "saveWebsite");
            },
            async sendApproval() {
                var res = await Api.websites.sendApproval(this.website);
                if (res.success === true) {
                    alert("that worked");
                    this.website = res.website;
                }
                else
                    this.showServerFailMessage(res, "sending approval");
            },
            async goLive() {
                var res = await Api.websites.goLive(this.website);
                if (res.success === true) {
                    alert("that worked");
                    this.website = res.website;
                }
                else
                    this.showServerFailMessage(res, "going live");
            },
            async sendTenantWelcome() {
                var res = await Api.websites.sendTenantWelcome(this.website);
                if (res.success === true) {
                    alert("that worked");
                    this.website = res.website;
                }
                else
                    this.showServerFailMessage(res, "sendTenantWelcome");
            },
            thumbUrl(thumb) {
                return `${this.$currentConfig.apiBaseUrl}${thumb}`;
            },
            notifyErrors(errorsArray) {
                var errorsLis = "";
                errorsArray.forEach((e) => {
                    if (e.length > 0) {
                        e.flat().forEach((ei) => {
                            errorsLis += `<li>${Help.removeFullStop(ei)}</li>`;
                        });
                    }
                });

                this.$notify({
                    timeout: 10000,
                    message: `Please <b>fix all errors</b> on the current page <b>to proceed</b><ul>${errorsLis}</ul>`,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },

            showServerFailMessage(res, action) {
                var msg = res.message ?? `Unknown problem on the server ${action} this building`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            }
        },
        async mounted() {
            Help.getEnumValues(BuildingStatus).forEach(num => { this.buildingStatuses.push({ id: Number(num), name: Help.formatEnumText(BuildingStatus[num]) }) });
            Help.getEnumValues(SiteTemplates).forEach(num => { this.siteTemplates.push({ id: Number(num), name: Help.formatEnumText(SiteTemplates[num]) }) });
            await this.fetchData();
        },
    }
</script>
<style lang="scss">
    /*.md-radio .md-radio-label*/
    .radio_large {
        /*border: solid 1px rgba(204, 204, 204, 0.52);*/
        height: 200px;
        padding: 1rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    }

        .radio_large:hover {
            box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        }

    .md-radio.radio_large .md-radio-label {
        width: 100%;
        height: 100%;
    }

    .radio_inner {
        height: 175px;
        width: 100%;
        position: relative;
    }

        .radio_inner img {
            border: solid 1px rgba(204, 204, 204, 0.52);
            height: 150px;
        }

        .radio_inner span {
            position: absolute;
            bottom: 0;
            left: 0;
        }

    .md-field .md-count {
        bottom: -10px;
    }

    .md-button.md-info:disabled,
    .md-button.md-info[disabled] {
        opacity: 0.35;
    }

    .horizontal_chbs {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 2rem;
    }
</style>